export default __webpack_public_path__ + "static/media/eye.28e2614a.svg";